import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  SET_PARTNER_DATA,
  UI_SET_VEHICLE_MODELS,
  UI_SET_VEHICLE_MARKS,
  UI_SET_VEHICLE_STYLE_BODY,
  UI_RESET_VEHICLE_MODELS,
  UI_RESET_VEHICLE_BODY_STYLES
} from 'store/actions/ui';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_UI_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_SET_LOADER_TEXT]: (state, text) => {
    state.loaderText = text;
  },

  [SET_PARTNER_DATA]: (state, data) => {
    const { logoFrontLeft, logoFrontRight, theme } = data;
    state.headerLogos = {
      logoFrontLeft,
      logoFrontRight
    };
    state.theme = theme;
  },

  [UI_SET_VEHICLE_MODELS]: (state, items) => {
    if (!items) {
      state.models = [];
      return;
    }
    state.models = items.map(model => ({
      label: model,
      value: model
    }));
  },

  [UI_SET_VEHICLE_MARKS]: (state, items) => {
    if (!items) {
      state.marks = [];
      return;
    }
    state.marks = items.map(mark => ({
      label: mark,
      value: mark
    }));
  },

  [UI_SET_VEHICLE_STYLE_BODY]: (state, items) => {
    if (!items) {
      state.bodyStyles = [];
      return;
    }
    state.bodyStyles = items.map(item => ({
      label: item,
      value: item
    }));
  },

  [UI_RESET_VEHICLE_MODELS]: state => {
    state.models = [];
  },

  [UI_RESET_VEHICLE_BODY_STYLES]: state => {
    state.bodyStyles = [];
  }
};
